module.exports = __webpack_public_path__ + "static/media/app9.700d50e8.png";